<template>
  <form action="../send/" name="simulationForm" method="post">
    <input type="hidden" name="detail" :value="formData" />
    <TheTitle :title="currentTitle" />
    <Transition appear>
      <TheMain v-if="currentPage == 'main'" />
      <TheOptions v-else-if="currentPage == 'options'" />
      <TheResult
        v-else-if="currentPage == 'result'"
      />
      <TheContact
        v-else-if="currentPage == 'contact'"
        @send-submit="submitForm()"
      />
    </Transition>
  </form>
</template>

<script>
import TheTitle from "./components/TheTitle.vue";
import TheMain from "./components/TheMain.vue";
import TheOptions from "./components/TheOptions.vue";
import TheResult from "./components/TheResult.vue";
import TheContact from "./components/TheContact.vue";
import { mapState, mapGetters } from "vuex";

export default {
  name: "PageSimulation",
  components: {
    TheTitle,
    TheMain,
    TheOptions,
    TheResult,
    TheContact,
  },
  data() {
    return {
      formData: "",
    };
  },
  computed: {
    ...mapState(["currentPage"]),
    ...mapGetters(["getFormValues"]),
    currentTitle() {
      switch (this.currentPage) {
        case "main":
        case "options":
          return "保険料シミュレーション";
        case "result":
          return "シミュレーション結果";
        case "contact":
          return "メール送信";
        default:
          return "保険料シミュレーション";
      }
    },
  },
  methods: {
    submitForm() {
      // this.formData = JSON.stringify(this.getFormValues);
      // // console.log(this.formData);
      // // console.log(document.simulationForm.data);
      // this.$nextTick(() => document.simulationForm.submit());
      document.cookie = "simulation="+JSON.stringify(this.getFormValues);
      window.location.href = "/contact/send";
    },
  },
};
</script>

<style scoped lang="scss">
.v-enter-active,
.v-leave-active {
  transition: opacity 0.5s ease;
}
.v-enter-from,
.v-leave-to {
  opacity: 0;
}
</style>
